export default __webpack_public_path__ + "static/media/dark1.6f70fe24.svg";